export { AgeIcon } from './age'
